import EmblaCarousel from "embla-carousel";

export default function initCarousel() {
  // Initialize Embla Carousel
  const emblaNodes = document.querySelectorAll(".js-carousel");

  if (emblaNodes.length > 0) {
    emblaNodes.forEach((emblaNode, index) => {
      // Skip if already initialized
      if (emblaNode.classList.contains("embla-initialized")) {
        return;
      }

      // Wait a bit for DOM to be ready
      setTimeout(() => {
        // Check if Flickity has taken over
        if (emblaNode.classList.contains("flickity-enabled")) {
          return;
        }

        // Ensure the carousel is visible
        emblaNode.style.opacity = "1";
        emblaNode.style.visibility = "visible";

        const emblaApi = EmblaCarousel(emblaNode, {
          loop: false,
          align: "start",
          slidesToScroll: 1,
          containScroll: "trimSnaps",
          dragFree: false,
          skipSnaps: false,
          duration: 25,
          breakpoints: {
            "(min-width: 576px)": {
              slidesToScroll: 1,
            },
            "(min-width: 768px)": {
              slidesToScroll: 1,
            },
            "(min-width: 992px)": {
              slidesToScroll: 1,
            },
          },
        });

        // Mark as initialized
        emblaNode.classList.add("embla-initialized");

        // Force visibility
        setTimeout(() => {
          emblaNode.style.opacity = "1";
          emblaNode.style.visibility = "visible";
        }, 100);

        // Get navigation buttons
        const prevBtn = emblaNode.parentElement.querySelector(".embla__prev");
        const nextBtn = emblaNode.parentElement.querySelector(".embla__next");
        const progressBar = emblaNode.parentElement.querySelector(
          ".js-carousel-progress-bar"
        );

        // Add event listeners for navigation buttons
        if (prevBtn) {
          prevBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            emblaApi.scrollPrev();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            emblaApi.scrollNext();
          });
        }

        // Update button states
        const updateButtonStates = () => {
          if (prevBtn) {
            prevBtn.disabled = !emblaApi.canScrollPrev();
          }
          if (nextBtn) {
            nextBtn.disabled = !emblaApi.canScrollNext();
          }
        };

        // Update progress bar
        const updateProgressBar = () => {
          if (progressBar) {
            const progress = Math.max(
              0,
              Math.min(1, emblaApi.scrollProgress())
            );
            progressBar.style.width = `${progress * 100}%`;
          }
        };

        // Listen to embla events
        emblaApi.on("init", () => {
          updateButtonStates();
          updateProgressBar();
        });

        emblaApi.on("select", () => {
          updateButtonStates();
        });

        emblaApi.on("scroll", () => {
          updateProgressBar();
        });

        emblaApi.on("resize", updateButtonStates);

        // Initial update
        setTimeout(() => {
          updateButtonStates();
          updateProgressBar();
        }, 100);
      }, 200);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initCarousel);
